module.exports = __webpack_public_path__ + "static/media/ex2.0609249d.png";